<template>
    <div>
        <div>
            <van-nav-bar
            title="修改昵称"
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"
            color="linear-gradient(to right, #ff9900, #ff3333)"
            />
        </div>
        <div class="form">
            <van-cell-group title="设置昵称">
                <van-field v-model="newNickName" placeholder="新昵称" class="phone" clearable/>
            </van-cell-group>
        </div>
        <div style="padding:0 3rem;" class="shure">
            <p class="smallgray">4-20个字符，可由中英文、数字、“_”、”+”组成</p>
            <p class="btn">
                <van-button round type="info" color="linear-gradient(to right, #ff9900, #ff3333)" @click="goTopage">确定</van-button>
            </p>
        </div>
    </div>
</template>

<script>
import {  NavBar, Row, Col,Icon, Field ,Cell, CellGroup , Button } from "vant";

export default {
    name: 'nickname',
    components: {
        [NavBar.name]: NavBar,
        [Row.name]: Row,
        [Col.name]: Col,
        [Icon.name]: Icon,
        [Field.name]: Field,
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [Button.name]: Button,
    },
    data(){
        return{
            newNickName:'',
        }
    },
    methods:{
        onClickLeft(){
            this.$router.go(-1)
        },
        goTopage(){
            let params = {
               session:this.local.get('session'),
               nickName:this.newNickName,
            };
            let _this = this
            this.request.post("/v1/user/nick-name", params)
            .then(res => {
                console.log(res);
                if(res.message == '修改成功'){
                    _this.$toast('修改成功')
                    _this.$router.push('personalcenter')
                }
            })
            .catch(err => {
                console.log(err);
            });
        }
    },
    created(){
        if(this.$route.query.nickName){
            this.newNickName = this.$route.query.nickName
        }
    },
    activated(){
        if(this.$route.query.nickName){
            this.newNickName = this.$route.query.nickName
        }
    }

}
</script>

<style lang="less" scoped>
.van-nav-bar {
    background: linear-gradient(to right, #ff9900, #ff3333);
    .van-icon,
    .van-nav-bar__text,
    .van-nav-bar__title {
      color: #fff;
    }
    .van-nav-bar__title{
        font-weight: bold;
        font-size: 1.25rem;
    }
}
.form {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .van-cell {
      border: 1px solid #ccc;
      border-radius: 1.5rem;
      line-height: 1.5rem;
      width: 22rem;
      margin-bottom: 1rem;
    }
    .van-cell-group__title{
        padding: 16px 16px 8px 0;
    }
}
.shure{
    .btn {
      .van-button {
        border-radius: 1.5rem;
        line-height: 1.5rem;
        width: 100%;
        margin-top: 0.5rem;
        font-size: 1.2rem;
        word-spacing: 0.5rem;
        margin-top: 4rem;
      }
    }
}
</style>